import React, { useEffect, useRef } from "react";
import ColorWheel from "./ColorWheel";

const UtilityIconPopoutGrid = ({ visible, anchor = { x: 0, y: 0 }, currentNumber = 1, onSelect, onClose, currentColor = '#ff0000', onColorChange }) => {
	const menuRef = useRef(null);

	useEffect(() => {
		if (!visible) return;
		const handleClickOutside = (e) => {
			if (menuRef.current && !menuRef.current.contains(e.target)) onClose && onClose();
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [visible, onClose]);

	if (!visible) return null;

	const styles = {
		position: "fixed",
		top: anchor.y,
		left: anchor.x,
		backgroundColor: "#222",
		border: "1px solid #444",
		borderRadius: "6px",
		boxShadow: "0 6px 18px rgba(0,0,0,0.6)",
		zIndex: 1100,
		padding: 8,
		display: "flex",
		flexDirection: "column",
		gap: 8,
		minWidth: 108,
	};

	const numberGridStyle = {
		display: "grid",
		gridTemplateColumns: "repeat(2, 44px)",
		gap: 8,
	};

	const btnStyle = (n) => ({
		width: 44,
		height: 44,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: n === currentNumber ? "#0af" : "#111",
		color: n === currentNumber ? "#001" : "#ddd",
		border: "1px solid #333",
		borderRadius: 6,
		cursor: "pointer",
		fontWeight: 700,
		fontSize: 16,
	});

	return (
		<div ref={menuRef} style={styles} role="dialog" aria-hidden={!visible}>
			<div style={numberGridStyle}>
				{[1, 2, 3, 4].map((n) => (
					<div key={n} style={btnStyle(n)} onClick={() => onSelect && onSelect(n)}>
						{n}
					</div>
				))}
			</div>
			<ColorWheel color={currentColor} onChange={onColorChange} />
		</div>
	);
};

export default UtilityIconPopoutGrid;
